module.exports = __webpack_public_path__ + "img/ic_Alipay.43ffa531.svg";